/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ReportConfigurationForAssessmentRunSummary extends models.ReportConfigurationForAssessmentRun {
    constructor() {
        super();
        this.setDiscriminator("ReportConfigurationForAssessmentRunSummary");
    }

    getFixupPrototypeFunction() { return ReportConfigurationForAssessmentRunSummary.fixupPrototype; }

    static newInstance(model: Partial<ReportConfigurationForAssessmentRunSummary>): ReportConfigurationForAssessmentRunSummary {
        let obj = Object.assign(new ReportConfigurationForAssessmentRunSummary(), model);
        ReportConfigurationForAssessmentRunSummary.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ReportConfigurationForAssessmentRunSummary>): ReportConfigurationForAssessmentRunSummary {
        if (!model) return null;
        return ReportConfigurationForAssessmentRunSummary.newInstance(<ReportConfigurationForAssessmentRunSummary> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ReportConfigurationForAssessmentRunSummary) {
        if (!obj) return;

        models.ReportConfigurationForAssessmentRunSummary.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ReportConfigurationForAssessmentRunSummary): boolean {
        if (models.ReportConfigurationForAssessmentRun.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ReportConfigurationForAssessmentRunSummary.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
